import PageNavBar from './PageNavBar';
import Logo from './Logo';
import PlatformNavigation from '@/components/navigationButton/PlatformNavigation';
import SagaNavigation from '@/components/navigationButton/SagaNavigation';
import TubeNavigation from '@/components/navigationButton/TubeNavigation';
import WwwNavigation from '@/components/navigationButton/WwwNavigation';
import { useLocation, useNavigate } from 'react-router-dom';

const NavigationBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
    return (
    <header className='fixed top-0 box-border w-full h-[62px] px-4 md:px-6 py-3 md:py-4 xl:py-6 bg-[#292929] shadow-lg z-30 flex items-center'>
      {/* Logo - Always on the left */}
      <div className='flex-1 flex items-center gap-4'>
        <Logo />
        <div className='hidden h-10 w-px shrink-0 bg-[#4B4B4B] md:block' />
        <div className='hidden xl:flex items-center gap-2 2xl:gap-0' >
          <PlatformNavigation
            label='Platform'
            id='nav-platform'
            onClick={() =>
              window.open(
                'https://platform.spacemap42.com',
                '_blank',
                'noopener,noreferrer'
              )
            }
          />
          <TubeNavigation
            label='Tube'
            id='nav-tube'
            onClick={() =>
              window.open(
                'https://tube.spacemap42.com',
                '_blank',
                'noopener,noreferrer'
              )
            }
          />
          <SagaNavigation
            label='Saga'
            id='nav-saga'
            onClick={() =>
              window.open(
                'https://platform.spacemap42.com/saga',
                '_blank',
                'noopener,noreferrer'
              )
            }
          />
          <WwwNavigation
            label='About Us'
            id='nav-www'
            onClick={() => navigate('/')  }
            active={location.pathname.startsWith('/')}
          />
        </div>
      </div>

      {/* Desktop: Centered Navigation */}
      <div className='absolute left-1/2 transform -translate-x-1/2 hidden xl:block'>
        <PageNavBar />
      </div>

      {/* Desktop: Login button on the right */}
      <div className='hidden md:flex justify-end items-center gap-4'>
        {/* <button className='text-[#A7A7A7] text-sm md:text-base md:border md:border-[#A7A7A7] md:rounded-md md:px-4 md:py-1'>
          Login
        </button> */}
        {/* Hamburger menu (md to xl) */}
        <div className='xl:hidden'>
          <PageNavBar />
        </div>
      </div>

      {/* Mobile: Hamburger menu on the right */}
      <div className='flex md:hidden justify-end'>
        <PageNavBar />
      </div>
    </header>
  );
};

export default NavigationBar;
